import gql from 'graphql-tag';

// Requester Group Mutations
const CREATE_REQUESTER_GROUP = gql`
  mutation createRequesterGroup($input: CreateRequesterGroupInput!) {
    createRequesterGroup(input: $input) {
      groupId
      name
      description
      groupUserAssignmentMethod
      userList {
        userId
        name
      }
      groupCondition
      updatedAt
      updatedBy {
        userId
        name
      }
    }
  }
`;

const UPDATE_REQUESTER_GROUP = gql`
  mutation updateRequesterGroup($input: UpdateRequesterGroupInput!) {
    updateRequesterGroup(input: $input) {
      groupId
      name
      description
      groupUserAssignmentMethod
      userList {
        userId
        name
      }
      groupCondition
      updatedAt
      updatedBy {
        userId
        name
      }
    }
  }
`;

const DELETE_REQUESTER_GROUPS = gql`
  mutation deleteRequesterGroups($input: [GroupIdentifierInput]!) {
    deleteRequesterGroups(input: $input)
  }
`;

// Requester Group Queries
const GET_REQUESTER_GROUPS = gql`
  query getRequesterGroups($listInfo: ListInfoInput!) {
    getRequesterGroups(listInfo: $listInfo) {
      requesterGroups {
        groupId
        name
        description
        updatedAt
        updatedBy {
          userId
          name
        }
      }
      listInfo {
        totalCount
        page
        sort {
          attribute
          order
        }
        condition
        pageSize
      }
    }
  }
`;

const GET_REQUESTER_GROUP = gql`
  query getRequesterGroup($input: GroupIdentifierInput!) {
    getRequesterGroup(input: $input) {
      groupId
      name
      description
      groupUserAssignmentMethod
      userList {
        userId
        name
        email
      }
      groupCondition
      updatedAt
      updatedBy {
        userId
        name
      }
    }
  }
`;

const GET_USER_META_FOR_REQUESTER_GROUP = gql`
  query getUserMetaForRequesterGroup {
    getUserMetaForRequesterGroup
  }
`;

const GET_BUSINESS_FUNCTION_LIST = gql`
  query getBusinessFunctionList {
    getBusinessFunctionList {
      businessFunctionId
      name
      head {
        userId
        name
      }
    }
  }
`;
const GET_BUSINESS_FUNCTION_LIST_V2 = gql`
  query getBusinessFunctions($listInfo: ListInfoInput!) {
    getBusinessFunctions(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        condition
      }
      businessFunctions {
        businessFunctionId
        name
        head {
          userId
          name
          email
        }
      }
    }
  }
`;

const GET_COMPANY_SITE_LIST = gql`
  query($input: ListInfoInput) {
    getCompanySiteList(input: $input) {
      sites {
        id
        name
        address {
          addressId
          line1
          line2
          line3
          city
          postalCode
          countryCode
          stateCode
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
      }
    }
  }
`;
const GET_COMPANY_SITE = gql`
  query($input: SiteIdentifierInput!) {
    getCompanySite(input: $input) {
      id
      name
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      timezoneCode
      working24x7
      contactNumber
      account {
        accountId
        name
      }
      hq
      installerInfo {
        id
        installerName
        installerDownloadUrl
        os
      }
      emailDomains
      address {
        addressId
        line1
        line2
        line3
        city
        postalCode
        countryCode
        stateCode
      }
    }
  }
`;

const GET_CLIENT_USER_INFO = gql`
  query getClientUserInfo($input: UserIdentifierInput!) {
    getClientUserInfo(input: $input)
  }
`;

// Ticket Form Queries
const GET_TICKET_FORMS_BY_REQUESTER_GROUP = gql`
  query getTicketFormsByRequesterGroup(
    $input: GetTicketFormsByRequesterGroupInput!
  ) {
    getTicketFormsByRequesterGroup(input: $input) {
      formId
      formName
      formDescription
      formStatus
      subject
      description
      defaultForm
      fieldDetails
      runbook {
        sopId
        name
      }
      allowDeleteOrClientVisibilityUpdate
    }
  }
`;

export {
  // Requester Group Mutations
  CREATE_REQUESTER_GROUP,
  UPDATE_REQUESTER_GROUP,
  DELETE_REQUESTER_GROUPS,
  // Requester Group Queries
  GET_REQUESTER_GROUPS,
  GET_REQUESTER_GROUP,
  GET_USER_META_FOR_REQUESTER_GROUP,
  // Ticket Form Queries
  GET_TICKET_FORMS_BY_REQUESTER_GROUP,
  // Other Queries
  GET_BUSINESS_FUNCTION_LIST,
  GET_COMPANY_SITE_LIST,
  GET_COMPANY_SITE,
  GET_CLIENT_USER_INFO,
  GET_BUSINESS_FUNCTION_LIST_V2
};
